export const extractById = entity => id => entity.find(item => item._id === id)
